import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Input, Popover, Radio, Row, Tabs } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import LoanTabDatas from "./LoanTabDatas";
import "../../assets/css/custom.css";
import SwitchBox from "./SwitchBox";
import SortBy from "./SortBy";
import { ServerAPI } from "../../common/ServerAPI";
import LoanSwitchBoxList from "./LoanSwitchBoxList";
import { useLocation, useNavigate } from "react-router-dom";
import PageLoader from "../../components/PageLoader";
import { useDispatch, useSelector } from "react-redux";
import { setLoanApplicationCaseFilter } from "../../redux/slice/dealerCommFilterSlice";
import SearchInput from "../../components/SearchInput/SearchInput";
import LoaderComp from "../../components/LoaderComp";
import { AuthenticationContext } from "../../App";
import { CommomPermission } from "../../common/Constants";

const DefaultFilters = {
  sortKey: "created_at", // name
  sortOrder: "desc", // asc
  id: 1,
  filter: "4",
  index: 4,
  provider_type: "",
  keyword: "",
};

const CaseList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pagePermission = location.state;
  // console.log("pagePermission===========", pagePermission)
  const dispatch = useDispatch();
  const { authData, } = useContext(
    AuthenticationContext
  );
  const FlooringPErmission = authData?.permissions?.filter((it) => it.name === "loan")?.map((itx) => itx?.submodules).flat()?.filter((its) => its?.name === "new-loan-application");
  const FloorPagePErmission = FlooringPErmission !== undefined && FlooringPErmission?.length > 0 ? FlooringPErmission[0] : CommomPermission;

  const filters = useSelector(
    (state) => state.dealerCommFilter.loanApplicationCaseFilter
  );
  const settingsData = useSelector(
    (state) => state?.settings?.loanProviderTypes
  );
  const [listDetails, setListDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loanDetailName, setLoanDetailName] = useState("");
  const [TotalData, setTotalData] = useState(0);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 20,
    apicall: true
  });
  const [applyFilters, setApplyFilters] = useState(
    Object.keys(filters)?.length > 0
      ? { ...filters, DefaultFilters }
      : DefaultFilters
  );

  const LoanCaseList = async (type) => {
    setLoading(true);
    try {
      let data = { ...applyFilters };
      delete data.id;
      const response = await ServerAPI.applicationList(
        data,
        type !== undefined && type !== null && type === "delete" ? 1 : pagination.currentPage,
        pagination.pageSize
      );
      if (response) {
        if (response.data) {
          setTotalData(response.total);
          if (type !== undefined && type !== null && type === "delete") {
            setListDetails(response.data);
          } else {
            setListDetails(listDetails?.length > 0 ? listDetails?.concat(response.data) : response.data);
          }

        }
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const handleSortBy = (val, value) => {
    switch (val) {
      case "Most Recent":
        setApplyFilters({
          ...applyFilters,
          sortKey: "created_at",
          sortOrder: "desc",
          id: value,
        });
        dispatch(
          setLoanApplicationCaseFilter({
            ...applyFilters,
            sortKey: "created_at",
            sortOrder: "desc",
            id: value,
          })
        );
        break;
      case "Loan Amount Asc":
        setApplyFilters({
          ...applyFilters,
          sortKey: "loanamount",
          sortOrder: "asc",
          id: value,
        });
        dispatch(
          setLoanApplicationCaseFilter({
            ...applyFilters,
            sortKey: "loanamount",
            sortOrder: "asc",
            id: value,
          })
        );
        break;
      case "Loan Amount Dsc":
        setApplyFilters({
          ...applyFilters,
          sortKey: "loanamount",
          sortOrder: "desc",
          id: value,
        });
        dispatch(
          setLoanApplicationCaseFilter({
            ...applyFilters,
            sortKey: "loanamount",
            sortOrder: "desc",
            id: value,
          })
        );
        break;
      default:
        break;
    }
  };
  const onPageChange = (obj) => {
    if (obj?.current > pagination?.currentPage) {
      setPagination({
        ...pagination,
        currentPage: obj.current,
        apicall: true
      });
    } else {
      setPagination({
        ...pagination,
        currentPage: obj.current,
        apicall: false
      });
    }
  };


  const items = [
    {
      label: "Incomplete",
      key: "4",
      children: (
        <LoanTabDatas
          data={listDetails}
          fetchLoanCase={LoanCaseList}
          type={"incomplete"}
          pagePermission={pagePermission}
          onPageChange={onPageChange}
          pagination={pagination}
        />
      ),
    },
    {
      label: "Pending",
      key: "1",
      children: (
        <LoanTabDatas
          data={listDetails}
          fetchLoanCase={LoanCaseList}
          type={"pending"}
          pagePermission={pagePermission}
          onPageChange={onPageChange}
          pagination={pagination}
        />
      ),
    },
    {
      label: "Disbursement",
      key: "2",
      children: (
        <LoanTabDatas
          data={listDetails}
          fetchLoanCase={LoanCaseList}
          type={"disbursement"}
          pagePermission={pagePermission}
          onPageChange={onPageChange}
          pagination={pagination}
        />
      ),
    },
    {
      label: "Expired",
      key: "3",
      children: (
        <LoanTabDatas
          data={listDetails}
          fetchLoanCase={LoanCaseList}
          type={"expired"}
          pagePermission={pagePermission}
          onPageChange={onPageChange}
          pagination={pagination}
        />
      ),
    },
  ];


  const handleSearch = (e) => {
    setApplyFilters({ ...applyFilters, keyword: e.target.value });
    dispatch(
      setLoanApplicationCaseFilter({
        ...applyFilters,
        keyword: e.target.value,
      })
    );
  };

  useEffect(() => {

  }, [loanDetailName]);

  useEffect(() => {
    LoanCaseList();
  }, [applyFilters]);

  useEffect(() => {
    if (listDetails?.length < TotalData && pagination?.apicall) {
      LoanCaseList();
    }
  }, [pagination]);
  useEffect(() => {
    LoanCaseList();
    localStorage.removeItem("tabValue");
  }, []);

  return (
    <div className="w-full min-h-screen bg-[#F5F5F5] overflow-x-clip">
      <div className="bg-white">
        <section className="common_container !bg-white">
          <header className="common-header flex flex-wrap gap-5 justify-between">
            <div className="common-header-body">
              <h1>Loan Application Cases</h1>
            </div>
            <div className="flex flex-wrap items-center justify-between gap-4 max-md:w-full">
              <SearchInput
                placeholder="Search Loan Application..."
                onChange={handleSearch}
                value={applyFilters?.keyword}
              />
              {pagePermission?.create_permission == 1 && (
                <Button
                  onClick={() => {
                    navigate("/loan-application", {
                      state: FloorPagePErmission,
                    });
                  }}
                  style={{ background: "#0b64fb" }}
                  type="primary"
                >
                  + New Loan Application
                </Button>
              )}
            </div>
          </header>
          <div className="mx-5">
            <LoanSwitchBoxList
              activeTabId={applyFilters.provider_type}
              handler={(value) => {
                setApplyFilters({ ...applyFilters, provider_type: value });
                dispatch(
                  setLoanApplicationCaseFilter({
                    ...applyFilters,
                    provider_type: value,
                  })
                );
                setListDetails([]);
                setPagination({
                  currentPage: 1,
                  pageSize: 20,
                  apicall: true
                });
              }}
              tabs={[{ name: "All", dataKey: "All", id: "" }].concat(
                settingsData
              )}
            />
          </div>
          <div className="app-container p-[0px_25px]">
            {loading ? (
              <LoaderComp />
            ) : (
              <Tabs
                defaultActiveKey={applyFilters?.filter}
                activeKey={applyFilters?.filter}
                onChange={(value) => {
                  setApplyFilters({ ...applyFilters, filter: value, index: value - 1 });
                  dispatch(
                    setLoanApplicationCaseFilter({
                      ...applyFilters,
                      filter: value,
                      index: value - 1,
                    })
                  );
                  setListDetails([]);
                  setPagination({
                    currentPage: 1,
                    pageSize: 20,
                    apicall: true
                  });

                }}
                items={items}
                tabBarExtraContent={
                  <div className="sort-container">
                    <SortBy
                      handleSortBy={handleSortBy}
                      value={applyFilters?.id}
                    />
                  </div>
                }
              ></Tabs>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default CaseList;
